<template>
    <div class="leading-5">
        <p class="!max-w-full">
            <i18n-t
                keypath="layout.footer.stars.tax.text"
                scope="global"
            >
                <MiscLink :to="t('layout.footer.stars.tax.link')" class="text-base-content underline hover:no-underline">
                    {{ t('layout.footer.stars.tax.linkText') }}
                </MiscLink>
            </i18n-t>
        </p>
        <p class="!max-w-full">
            <i18n-t
                keypath="layout.footer.stars.shipping.text"
                scope="global"
            >
                <MiscLink :to="t('layout.footer.stars.shipping.link')" class="text-base-content underline hover:no-underline">
                    {{ t('layout.footer.stars.shipping.linkText') }}
                </MiscLink>
            </i18n-t>
        </p>
        <p class="!max-w-full">{{ t('layout.footer.stars.coupons') }}</p>
        <p class="!max-w-full">{{ t('layout.footer.stars.promotions') }}</p>
    </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n'

const {t} = useI18n()
</script>